import React, { useRef } from "react";
import PicturesLoaded from "./PicturesLoaded";
import Camera from "components/Camera";
import MediaModal from "./Modals/MediaModal";
import ContinueModal from "./Modals/ContinueModal";
import { usePicturesUploadRequired } from "./usePicturesUploadRequired";
import { noop } from "utils/global-utils";
import { PicturesContainer, SplitPanel } from "../UploadPicturesStyled";

const PicturesUploadRequired = ({
  sendPictures = noop,
  pictures = [],
  doneWithPictures,
  numberOfPictures
}) => {
  const uploadPicturesInput = useRef(null);
  const {
    closeCamera,
    discardPicture,
    handleImage,
    onCameraClick,
    onTakePhoto,
    isCameraOpen,
    isLoading
  } = usePicturesUploadRequired();

  return (
    <PicturesContainer
      data-category="take_photos_incident"
      data-testid="upload_photos_card"
    >
      <SplitPanel>
        <input
          data-testid="input-files"
          type="file"
          ref={uploadPicturesInput}
          multiple
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleImage}
          value=""
        />
        <PicturesLoaded
          doneWithPictures={doneWithPictures}
          uploadPicturesInput={uploadPicturesInput}
          discardPicture={discardPicture}
          sendPictures={sendPictures}
          onCameraClick={onCameraClick}
          maximum_number_of_pictures={numberOfPictures}
          isLoading={isLoading}
          uploadPictures={onCameraClick}
          pictures={pictures}
        />
        {isCameraOpen && (
          <Camera
            onTakePhoto={onTakePhoto}
            handleImage={handleImage}
            closeCamera={closeCamera}
          />
        )}
        <MediaModal uploadPicturesInput={uploadPicturesInput} />
        <ContinueModal doneWithPictures={doneWithPictures} />
      </SplitPanel>
    </PicturesContainer>
  );
};

export default PicturesUploadRequired;
